export default __webpack_public_path__ + "static/media/truck.5fc64bd0.pdf";